export default __webpack_public_path__ + "static/media/xano-adalo.523a8e6e.svg";